const TRACK_VERSION_META_FIELDS = [
  'id',
  'versionCount',
  'latestVersionNumber',
  'activeVersionFingerprint',
  'lastVersionSavedAt'
];

function deepClone (value) {
  try {
    return structuredClone(value);
  }
  catch {
    return JSON.parse(JSON.stringify(value));
  }
}

function hashString (value) {
  let hash = 2166136261;
  for (let index = 0; index < value.length; index++) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return `v${(hash >>> 0).toString(36)}`;
}

export function buildTrackVersionSnapshot (trackRecord) {
  const snapshot = deepClone(trackRecord || {});
  TRACK_VERSION_META_FIELDS.forEach((field) => {
    delete snapshot[field];
  });
  return snapshot;
}

export function computeTrackVersionFingerprint (trackRecord) {
  const snapshot = buildTrackVersionSnapshot(trackRecord);
  return hashString(JSON.stringify({
    title: snapshot?.title || '',
    typeTitle: snapshot?.typeTitle || '',
    geojson: snapshot?.geojson || null
  }));
}

export function buildTrackedRouteVersionRecord (trackRecord, options = {}) {
  const snapshot = buildTrackVersionSnapshot(trackRecord);
  const versionNumber = Number(options.versionNumber) || 1;
  const createdAt = Number(options.createdAt) || Date.now();
  const source = String(options.source || 'manual');
  const snapshotFingerprint = computeTrackVersionFingerprint(snapshot);

  return {
    trackId: Number(options.trackId),
    versionNumber,
    createdAt,
    label: options.label || `Version ${versionNumber}`,
    source,
    sourceMeta: options.sourceMeta ? deepClone(options.sourceMeta) : null,
    title: snapshot?.title || '',
    typeTitle: snapshot?.typeTitle || '',
    pointCount: Number(snapshot?.pointCount) || 0,
    totalDistance: snapshot?.totalDistance ?? 0,
    snapshotFingerprint,
    snapshot
  };
}

export function applyTrackedRouteVersionToRecord (trackRecord, versionRecord, options = {}) {
  const snapshot = deepClone(versionRecord?.snapshot || {});
  const next = {
    ...deepClone(trackRecord || {}),
    ...snapshot
  };

  next.id = trackRecord?.id;
  next.versionCount = Number(options.versionCount) || Number(trackRecord?.versionCount) || 0;
  next.latestVersionNumber = Number(options.latestVersionNumber) || Number(trackRecord?.latestVersionNumber) || Number(versionRecord?.versionNumber) || 0;
  next.activeVersionFingerprint = versionRecord?.snapshotFingerprint || computeTrackVersionFingerprint(next);
  next.lastVersionSavedAt = Number(options.lastVersionSavedAt) || Number(trackRecord?.lastVersionSavedAt) || Date.now();
  return next;
}

export function getTrackVersionSourceLabel (source) {
  const normalized = String(source || '').toLowerCase();
  if (normalized === 'original') return 'Original';
  if (normalized === 'correction') return 'Correction';
  if (normalized === 'import') return 'Import';
  return 'Manual';
}
